
import { addAutoPlayForTabs } from '@/assets/js/mutual-fund-and-home-slider.js'
  var left_imgUrl = require("@/styles/img/invest-in-share-market/left.svg");
  var right_imgUrl =require("@/styles/img/invest-in-share-market/right.svg");

  $(".team_mb_slider").owlCarousel({
    stagePadding: 1,
    loop: false,
    margin: 16,
    nav: false,
    dots: false,
    center: false,
    navText: [
      "<img src=" + left_imgUrl + " />",
      "<img src=" + right_imgUrl + " />",
    ],
    responsive: {
      0: {
        items: 1,
        nav: false,
        dots: true,
        loop: false,
        navText: ["", ""],
      },
      768: {
        items: 4,
        nav: true,
      },
    },
    onInitialized: addDotButtonText,
    onResized: addDotButtonText
  });

  $(".team_mb_truths").owlCarousel({
    stagePadding: 1,
    loop: false,
    margin: 16,
    nav: false,
    dots: false,
    center: false,
    navText: [
      "<img src=" + left_imgUrl + " />",
      "<img src=" + right_imgUrl + " />",
    ],
    responsive: {
      0: {
        items: 1,
        nav: false,
        dots: true,
        loop: false,
        navText: ["", ""],
      },
      768: {
        items: 3,
        loop: false,
        nav: true,
      },
      1199: {
        items: 3,
        loop: false,
        nav: true,
      },
      1600: {
        items: 4,
        loop: false,
        nav: true,
      },
    },
  });

  $(window).on("scroll touchmove", function () {
    var scrollPosition = $(window).scrollTop();
    var section = $(".upstox-toggle-btn-sec");
    var className = "invest-scrolled";

    if (scrollPosition > 250 || scrollPosition > 400) {
      section.addClass(className);
    } else {
      section.removeClass(className);
    }
  });

  addAutoPlayForTabs(".int_tab_list");

  var $status = $('<div id="countDiv-slider"></div>');
  var $slickElement = $(".truth-investing");

  $slickElement.on(
    "init reInit beforeChange",
    function (event, slick, currentSlide, nextSlide) {

      if (!slick.$dots) {
        return;
      }

      if (typeof nextSlide === 'undefined') {
        nextSlide = 0;
      }
      
      var i = (nextSlide ? nextSlide : 0) + 1; 
      var countData = $status.text(i + "/" + 6);
      $(".truth-investing li").removeClass("slick-active");
      $(".truth-investing li:eq(" + nextSlide + ")").addClass("slick-active");
      $(".slick-dots .slick-active").append(countData);
    }
  );

  $slickElement.slick({
    dots: true,
    infinite: true,
    variableWidth: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
  });

  $("#invest_next").click(function () {
    $(".list-unstyled-funds > .active").next("li").find("a").trigger("click");
  });

  $("#invest_prev").click(function () {
    $(".list-unstyled-funds > .active").prev("li").find("a").trigger("click");
  });

  $("#trading_next").click(function () {
    $(".list-unstyled-trading > .active")
      .next("li")
      .find("a")
      .trigger("click");
  });

  $("#trading_prev").click(function () {
    $(".list-unstyled-trading > .active")
      .prev("li")
      .find("a")
      .trigger("click");
  });

  $("#trading_next_power").click(function () {
    $("#list-unstyled-power > .active").next("li").find("a").trigger("click");
  });

  $("#trading_prev_power").click(function () {
    $("#list-unstyled-power > .active").prev("li").find("a").trigger("click");
  });

  $("#invest_next_stocks").click(function () {
    $("#list-unstyled-stocks > .active")
      .next("li")
      .find("a")
      .trigger("click");
  });

  $("#invest_prev_stocks").click(function () {
    $("#list-unstyled-stocks > .active")
      .prev("li")
      .find("a")
      .trigger("click");
  });

  /********First slider Start*********** */
  var tabCounttrading = $("#invest-funds .trades-power .tab-pane").length;
  if (tabCounttrading > 1) {
    $("#invest_next").addClass("active");
  }
  // handle the click event of the next button
  $("#invest_next").click(function () {
    var activeTab = $("#invest-funds .trades-power .tab-pane.active");
    var nextTab = activeTab.next(".tab-pane");
    if (nextTab.length > 0) {
      // remove active class from current tab
      activeTab.removeClass("active");
      // add active class to next tab
      nextTab.addClass("active");
      // update the button states
      investupdateButtonStates(nextTab.index());
    }
  });
  // handle the click event of the previous button
  $("#invest_prev").click(function () {
    var activeTab = $("#invest-funds .trades-power .tab-pane.active");
    var prevTab = activeTab.prev(".tab-pane");
    if (prevTab.length > 0) {
      // remove active class from current tab
      activeTab.removeClass("active");
      // add active class to previous tab
      prevTab.addClass("active");
      // update the button states
      investupdateButtonStates(prevTab.index());
    }
  });
  // function to update the button states
  function investupdateButtonStates(activeTabIndex) {
    // remove active class from all buttons
    $(".invest-slide-arrow .invest-next-funds").removeClass("active");
    // add active class to next button if there is a next tab
    if (activeTabIndex < tabCounttrading - 1) {
      $("#invest_next").addClass("active");
    }
    // add active class to previous button if there is a previous tab
    if (activeTabIndex > 0) {
      $("#invest_prev").addClass("active");
    }
  }
  /********First slider End*********** */

  /********Sec slider Start*********** */

  var tabCount = $("#upstox-invest .etf .tab-pane").length;
  // set the initial state of the buttons
  if (tabCount > 1) {
    $("#trading_next").addClass("active");
  }
  // handle the click event of the next button
  $("#trading_next").click(function () {
    var activeTab = $("#upstox-invest .etf .tab-pane.active");
    var nextTab = activeTab.next(".tab-pane");
    if (nextTab.length > 0) {
      // remove active class from current tab
      activeTab.removeClass("active");
      // add active class to next tab
      nextTab.addClass("active");
      // update the button states
      updateButtonStates(nextTab.index());
    }
  });
  // handle the click event of the previous button
  $("#trading_prev").click(function () {
    var activeTab = $("#upstox-invest .etf .tab-pane.active");
    var prevTab = activeTab.prev(".tab-pane");
    if (prevTab.length > 0) {
      // remove active class from current tab
      activeTab.removeClass("active");
      // add active class to previous tab
      prevTab.addClass("active");
      // update the button states
      updateButtonStates(prevTab.index());
    }
  });
  // function to update the button states
  function updateButtonStates(activeTabIndex) {
    // remove active class from all buttons
    $("#invest-slide-upstox .invest-trade-upstox").removeClass("active");
    // add active class to next button if there is a next tab
    if (activeTabIndex < tabCount - 1) {
      $("#trading_next").addClass("active");
    }
    // add active class to previous button if there is a previous tab
    if (activeTabIndex > 0) {
      $("#trading_prev").addClass("active");
    }
  }

  /********Sec slider Emd*********** */

  /********third slider Start*********** */
  var tabCounttrading = $("#invest-power .trades-ipo .tab-pane").length;
  // set the initial state of the buttons
  if (tabCounttrading > 1) {
    $("#trading_next_power").addClass("active");
  }
  // handle the click event of the next button
  $("#trading_next_power").click(function () {
    var activeTab = $("#invest-power .trades-ipo .tab-pane.active");
    var nextTab = activeTab.next(".tab-pane");
    if (nextTab.length > 0) {
      // remove active class from current tab
      activeTab.removeClass("active");
      // add active class to next tab
      nextTab.addClass("active");
      // update the button states
      powerupdateButtonStates(nextTab.index());
    }
  });
  // handle the click event of the previous button
  $("#trading_prev_power").click(function () {
    var activeTab = $("#invest-power .trades-ipo .tab-pane.active");
    var prevTab = activeTab.prev(".tab-pane");
    if (prevTab.length > 0) {
      // remove active class from current tab
      activeTab.removeClass("active");
      // add active class to previous tab
      prevTab.addClass("active");
      // update the button states
      powerupdateButtonStates(prevTab.index());
    }
  });
  // function to update the button states
  function powerupdateButtonStates(activeTabIndex) {
    // remove active class from all buttons
    $(".invest-slide-arrow .invest-arrow-power").removeClass("active");
    // add active class to next button if there is a next tab
    if (activeTabIndex < tabCounttrading - 1) {
      $("#trading_next_power").addClass("active");
    }
    // add active class to previous button if there is a previous tab
    if (activeTabIndex > 0) {
      $("#trading_prev_power").addClass("active");
    }
  }
  /********third slider Emd*********** */

  /********four slider Start*********** */
  var tabCount = $(
    "#invest-funds-stocks .trades-power-stocks .tab-pane"
  ).length;
  // set the initial state of the buttons
  if (tabCount > 1) {
    $("#invest_next_stocks").addClass("active");
  }
  // handle the click event of the next button
  $("#invest_next_stocks").click(function () {
    var activeTab = $(
      "#invest-funds-stocks .trades-power-stocks .tab-pane.active"
    );
    var nextTab = activeTab.next(".tab-pane");
    if (nextTab.length > 0) {
      // remove active class from current tab
      activeTab.removeClass("active");
      // add active class to next tab
      nextTab.addClass("active");
      // update the button states
      stocksupdateButtonStates(nextTab.index());
    }
  });
  // handle the click event of the previous button
  $("#invest_prev_stocks").click(function () {
    var activeTab = $(
      "#invest-funds-stocks .trades-power-stocks .tab-pane.active"
    );
    var prevTab = activeTab.prev(".tab-pane");
    if (prevTab.length > 0) {
      // remove active class from current tab
      activeTab.removeClass("active");
      // add active class to previous tab
      prevTab.addClass("active");
      // update the button states
      stocksupdateButtonStates(prevTab.index());
    }
  });
  // function to update the button states
  function stocksupdateButtonStates(activeTabIndex) {
    // remove active class from all buttons
    $("#invest-slide-stock .invest-next-stocks").removeClass("active");
    // add active class to next button if there is a next tab
    if (activeTabIndex < tabCount - 1) {
      $("#invest_next_stocks").addClass("active");
    }
    // add active class to previous button if there is a previous tab
    if (activeTabIndex > 0) {
      $("#invest_prev_stocks").addClass("active");
    }
  }
  /********four slider Emd*********** */

  $(".truths-investing-section .next-slide-truths").click(function () {
    // Remove "active" class from all <li> elements
    $(".truths-investing-section .custom_arrows_team li").removeClass(
      "active"
    );

    // Add "active" class to the previous <li> element
    $(this).prev().addClass("active");
  });

  $(".truths-investing-section .prev-slide-truths").click(function () {
    // Remove "active" class from all <li> elements
    $(".truths-investing-section .custom_arrows_team li").removeClass(
      "active"
    );

    // Add "active" class to the next <li> element
    $(this).next().addClass("active");
  });

  $(".mobile-popup .modal").on("click", function () {
    var modalId = jQuery(this).attr("id");
    $("#" + modalId + " .close").click();
  });

  function addDotButtonText() {

    // loop through each dot element
    $('.owl-dot').each(function() {
        // remove old text nodes
        $(this).find('.offscreen').remove();

        // grab its (zero-based) order in the series
        let idx = $(this).index() + 1;

        // append a span to the button containing descriptive text
        $(this).append('<span class="offscreen">upstox ' + idx + '</span>');
    });
}
